import { CSP_NONCE, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { first, timer } from 'rxjs';
import { OnFinish } from 'src/app/rokezzz/api/api/on-finish';
import { RokezzzWindowService } from 'src/app/rokezzz/window/services/window.service';
import { RokezzzPlatformService } from 'src/app/rokezzz/platform/services/platform.service';
import { coreConfig } from 'src/app/core/models/core-config';

@Injectable({
    providedIn: 'root'
})
export class RokezzzGtagService {
    private readonly gtagApiKey: string = environment.gtagApiKey;

    private gtagLoaded: boolean = false;
    private gtagLoading: boolean = false;
    private renderer: Renderer2;
    private document: Document;

    public constructor(
        @Inject(CSP_NONCE) private readonly cspNonce: string,
        private readonly rokezzzWindowService: RokezzzWindowService,
        private readonly rokezzzPlatformService: RokezzzPlatformService,
        private readonly rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.document = this.rokezzzWindowService.getDocument();
    }

    public init(): void {
        this.sendToAnalytics((): void => { });
    }

    private sendToAnalytics(onFinish: OnFinish<void>, delay: number = coreConfig.externalScriptLoadDelay): void {
        if (this.rokezzzPlatformService.isPlatformServer()) {
            return;
        }

        if (this.gtagLoaded) {
            onFinish();

            return;
        }

        if (this.gtagLoading) {
            timer(1000).pipe(first()).subscribe(() => this.sendToAnalytics(onFinish));

            return;
        }

        this.gtagLoading = true;

        timer(delay).pipe(
            first()
        ).subscribe(() => {
            const scriptElement: HTMLElement = this.renderer.createElement('script'),
                inlineScript = this.renderer.createText(`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${this.gtagApiKey}');`);

            scriptElement.nonce = this.cspNonce;
            this.renderer.appendChild(scriptElement, inlineScript);
            this.renderer.appendChild(this.document.head, scriptElement);

            const noscriptElement: HTMLElement = this.renderer.createElement('noscript'),
                inlineNoscript = this.renderer.createText(`<iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtagApiKey}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`);

            noscriptElement.nonce = this.cspNonce;
            this.renderer.appendChild(noscriptElement, inlineNoscript);
            this.renderer.appendChild(this.document.body, noscriptElement);
            this.gtagLoaded = true;
        });
    }
}
